import React, { FC } from 'react'

import { LineTileShape, LineTileSize } from '@/constants/common'
import { focusIds } from '@/constants/focus'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { TileProps } from '@/types/componentsPropsTypes'

import { useViewMoreImage } from './hooks/useViewMoreImage'
import { TextShowMore, TileLineElem } from './styles'

type ViewMoreTileProps = {
  className: string
  onClick: () => void
  onMouseOver?: () => void
}

export const ViewMoreTile: FC<TileProps> = ({
  focusId,
  data,
  handleToggle,
  tileShape = LineTileShape.ASPECT16x9,
  tileSize = LineTileSize.DEFAULT,
  categoryId,
  onMouseOverTile,
}) => {
  const { t } = useCommonTranslation()
  const imgUrl = useViewMoreImage({ tileShape, tileSize, categoryId })
  const isFirstTile = focusId.includes(focusIds.VIEW_MORE_FIRST)
  const tileText = t(isFirstTile ? 'viewAll' : 'viewMore')

  const onSelected = () => {
    handleToggle?.({
      tileData: data,
      focusId,
      tileIndex: isFirstTile ? 0 : undefined,
    })
  }

  const tileProps: ViewMoreTileProps = {
    className: 'slider__item',
    onClick: onSelected,
    onMouseOver: () => onMouseOverTile?.(data, focusId),
  }

  return (
    <TileLineElem {...tileProps} $tileShape={tileShape} $tileSize={tileSize}>
      {imgUrl && <img src={imgUrl} alt="" />}
      <TextShowMore $tileShape={tileShape} $tileSize={tileSize}>
        {tileText}
      </TextShowMore>
    </TileLineElem>
  )
}
